import React from "react";
import FlusterPlayerList from "../components/FlusterPlayerList";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";
const FLUSAroundTheHornQuestion = ({
  roomId,
  isAnswererPlayer,
  question,
  answererPlayer,
  users
}) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="around-the-horn-question"
    >
      {isAnswererPlayer ? (
        <FlusterPlayerList
          roomId={roomId}
          users={users}
          answererPlayer={answererPlayer}
          isAroundTheHorn={true}
          socketCall={true}
        />
      ) : (
        <motion.div
          variants={staticBounceVariants}
          className="question-card-main"
        >
          <div className="fluster-card-container">
            <div className="horn-question">
              <p>{question?.question}</p>
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default FLUSAroundTheHornQuestion;
